import { InjectionToken, Provider } from '@angular/core';
import { UnleashService } from '@karelics/angular-unleash-proxy-client';

export const ANZ_SSO_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('ANZ_SSO_ENABLED');

export const ANZ_DISABLE_PHYSICAL_GIFT_CARD_UNLEASH_KEY =
  'rd_anz_disable_physical_gift_card';
export const ANZ_DISABLE_PHYSICAL_GIFT_CARD: InjectionToken<boolean> =
  new InjectionToken<boolean>('ANZ_DISABLE_PHYSICAL_GIFT_CARD', {
    factory: () => false,
  });
export const provideAnzDisablePhysicalGiftCard = (): Provider => ({
  provide: ANZ_DISABLE_PHYSICAL_GIFT_CARD,
  useFactory: (unleashService: UnleashService) =>
    unleashService.isEnabled(ANZ_DISABLE_PHYSICAL_GIFT_CARD_UNLEASH_KEY),
  deps: [UnleashService],
});
